<template>
<v-app>
<v-main>
</v-main>
</v-app>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },

    mounted () {
        this.$router.push({
            'name': 'red-chirp-provide-secret',
            'params' : {
                'secret_type': 'wine-direct-credentials',
            }
        });
    },
}
</script>

<style lang="scss" scoped>
</style>

